import BasketItem from './BasketItem'
import BasketPromocode from './BasketPromocode'

export default class Basket {
  constructor (data) {
    if (!data || !data.id) throw new Error('Wrong Basket data')

    this.id = data.id
    this.items = data.positions.map(o => new BasketItem(o))
    this.itemsCount = data.positions_count || 0
    this.totalPrice = data.total_price || 0
    this.totalDiscount = data.total_discount || 0
    this.totalNewPrice = data.total_new_price || 0
    this.promocode = data.promocode ? new BasketPromocode(data.promocode) : null
  }
}
